import {
  FETCH_ORDERS_REQUEST,
  SEARCH_ORDERS_REQUEST,
  FETCH_ORDER_DETAILS_REQUEST,
  APPROVE_ORDER_REQUEST,
  REJECT_ORDER_REQUEST,
  FetchOrdersOptions,
  SearchOrdersOptions,
} from "@/types/models/order";

export const fetchOrders = (options: FetchOrdersOptions = {}) => ({
  type: FETCH_ORDERS_REQUEST,
  payload: options,
});

export const searchOrders = (options: SearchOrdersOptions) => ({
  type: SEARCH_ORDERS_REQUEST,
  payload: options,
});

export const fetchOrderDetails = (orderId: string) => ({
  type: FETCH_ORDER_DETAILS_REQUEST,
  payload: orderId,
});

export const approveOrder = (orderId: string) => ({
  type: APPROVE_ORDER_REQUEST,
  payload: orderId,
});

export const rejectOrder = (orderId: string) => ({
  type: REJECT_ORDER_REQUEST,
  payload: orderId,
});

export const orderActions = {
  fetchOrders,
  searchOrders,
  fetchOrderDetails,
  approveOrder,
  rejectOrder,
};
